// Additional service catalogue for the "What people ask for" expanded list.
// Each item is a quick-glance chip — not a full image card.
import {
  Pill,
  ShoppingBasket,
  Cake,
  PenLine,
  KeyRound,
  Footprints,
  Scissors,
  BatteryCharging,
  Leaf,
  Bone,
  Newspaper,
  Shirt,
  TestTube,
  Carrot,
  Croissant,
  FileBox,
  Gift,
  PartyPopper,
  Fish,
  Coffee,
  Wrench,
  Wallet,
  Stamp,
  Sparkles,
  FileText
} from "lucide-react";

export const MORE_SERVICES = [
  // { icon: Pill, title: "Medicines pickup", note: "Apollo, MedPlus, local chemists" },

  { icon: ShoppingBasket, title: "Grocery run", note: "From nearby local stores"},
  { icon: Cake, title: "Cake & bakery", note: "Cakes, pastries and baked items"},
  { icon: PenLine, title: "Stationery", note: "Notebooks, charts and supplies"},
  { icon: KeyRound, title: "Key cutting", note: "Duplicate keys for home or vehicle"},
  { icon: Footprints, title: "Shoe repair", note: "Polish, sole fixes and stitching"},
  { icon: Scissors, title: "Tailor pickup", note: "Alterations, stitching, etc"},
  { icon: Wrench, title: "Kitchen appliance repair", note: "Mixer, grinder, small appliance fixes"},
  { icon: Leaf, title: "Plants & nursery", note: "Pots, soil and indoor plants"},
  { icon: Bone, title: "Pet supplies", note: "Food, treats and basic essentials"},
  { icon: Newspaper, title: "Newspapers & magazines", note: "Daily or back issues"},
  { icon: Shirt, title: "Dry cleaning pickup", note: "Clothes, sarees and fabrics"},
  { icon: FileText, title: "Stamp paper & documents", note: "Stamp papers and basic document"},
  { icon: Carrot, title: "Fruits & vegetables", note: "Fresh produce from local vendors"},
  { icon: Croissant, title: "Breakfast pickup", note: "Fresh items from nearby shops"},
  { icon: FileBox, title: "Document delivery", note: "Pickup and drop within your area"},
  { icon: Gift, title: "Gift wrapping & cards", note: "Simple wrapping and greeting cards"},
  { icon: Fish, title: "Meat & seafood", note: "Fresh items from local shops"},
  { icon: Coffee, title: "Coffee & essentials", note: "Beans, powder and basic supplies"},
  { icon: Stamp, title: "Courier & post drop", note: "Drop-off and basic handling"},
  { icon: Sparkles, title: "Anything else", note: "Tell us what you need, we’ll try to help"}
];
